import React, { useState, useRef, useEffect } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import neshanSearch from "client-sdk/src/common/neshanSearch";
import handleError from "../../utils/handleError";
import L from "leaflet";

// style
import { CircularProgress, createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "leaflet/dist/leaflet.css";
import "./style.css";

interface SearchResult {
  geom: {
    coordinates: [number, number];
  };
  title: string;
  address: string;
  notFound?: boolean;
}

const iconPerson = new L.Icon({
  iconUrl: "/pin.png",
  iconRetinaUrl: "/pin.png",
  iconSize: new L.Point(37, 37),
  className: "map-position",
});

const useStyles = makeStyles((theme) =>
  createStyles({
    loadingStyle: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      zIndex: 999,
      background: "#9d9d9dad",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

const MapboxMap = ({
  loadingSubmitMap = false,
  style,
  setLatlng,
  positionMarker,
}: any) => {
  const [text, setText] = useState<string>("");
  const [results, setResults] = useState<SearchResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [position, setPosition] = useState<[number, number]>(
    positionMarker || [35.7219, 51.3347]
  );

  const inputRef = useRef<HTMLInputElement | null>(null);
  const markerRef = useRef(null);
  const classes = useStyles();

  const lat = 35.7219;
  const lng = 51.3347;

  useEffect(() => {
    if (!positionMarker?.lat) setPosition([35.7219, 51.3347]);
  }, []);

  useEffect(() => {
    if (text.length > 1) {
      setIsLoading(true);
      const debounceTimeout = setTimeout(async () => {
        try {
          const res = await neshanSearch(text, lat, lng);
          if (res.ok) {
            setResults(res.res.items);
            setIsLoading(false);
          } else {
            setResults([]);
          }
        } catch (error) {
          handleError(error);
          setResults([]);
          setIsLoading(false);
        }
      }, 1000);
      return () => clearTimeout(debounceTimeout);
    }
  }, [text]);

  const handleMapClick = (e: any) => {
    const { lat, lng } = e.latlng;
    setPosition([lat, lng]);
    setLatlng({ lat, lng });
  };
  const handlerclearTextInput = () => {
    inputRef.current?.focus();
    setText("");
    setResults([]);
  };

  return (
    <div>
      <div style={{ marginBottom: "10px", textAlign: "center" }}>
        <div style={style}>
          <div className="search-box__item flex-row">
            <input
              ref={inputRef}
              autoComplete="off"
              type="text"
              id="search"
              placeholder="جستجو آدرس..."
              onChange={(e) => setText(e.target.value)}
              value={text}
            />
            {results.length > 0 && (
              <div onClick={handlerclearTextInput} className="clear-seach">
                <span> &#10006; </span>
              </div>
            )}
          </div>
          {text.length > 1 && (
            <div className="search-box__item search-results">
              {isLoading ? (
                <div className="search-result-item">
                  <p className="search-result-item-title">درحال جستجو ...</p>
                </div>
              ) : (
                results.map((item: any, index) => (
                  <div
                    className="search-result-item"
                    key={index}
                    onClick={() => {
                      setPosition([item.location.y, item.location.x]);
                      setLatlng({
                        lat: item.location.y,
                        lng: item.location.x,
                      });
                      setResults([]);
                    }}>
                    <p className="search-result-item-title">{item.title}</p>
                    <p className="search-result-item-address">{item.address}</p>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {loadingSubmitMap && (
          <div className={classes.loadingStyle}>
            <CircularProgress />
          </div>
        )}
        <Map
          center={position}
          zoom={16}
          style={{ height: "700px", width: "100%" }}
          onClick={handleMapClick}>
          <TileLayer
            url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
            maxZoom={40}
            minZoom={0}
          />
          <Marker icon={iconPerson} position={position} ref={markerRef}>
            <Popup>موقعیت فعلی شما</Popup>
          </Marker>
        </Map>
      </div>
    </div>
  );
};

export default MapboxMap;
